import React from 'react';

import sections from '../data/sections';
import Timeline from './timeline/Timeline';

import './Section.css';

export default ({ year }) => (
  <section className="Section" id={year}>
    <h2 className="Section__header">{year}</h2>
    <div className="Section__preface">
      <span className="Section__preface-text">{sections[year].preface}</span>
    </div>
    <div className="Section__timeline">
      <Timeline year={year} summary={sections[year].summary} />
    </div>
    <div className="Section__navigation">
      <a
        className="Section__navigation-link"
        href="#top"
      >
        ↑ Back to Top ↑
      </a>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/Section.js